<div class="fixed inset-0 z-40 flex items-center justify-center bg-black bg-opacity-50 transition-opacity"
*ngIf="displayDialog">
<!-- Scrollable content wrapper for controlling overflow -->
<div class="w-full h-full flex items-center justify-center overflow-auto">
  <!-- Popup Content Card -->
  <div
    class="relative max-w-2xl w-full bg-white rounded-xl shadow-2xl p-6 md:p-8 z-50 animate-fadeIn max-h-[90vh] overflow-y-auto">
    <!-- Close Button -->
    <button type="button" (click)="closeDialog.emit()"
      class="absolute top-3 right-3 p-2 text-slate-500 hover:text-blue-600 rounded-full hover:bg-slate-100 transition"
      aria-label="Close">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>

    <!-- Header -->
    <div class="mb-6">
      <h1 class="text-xl md:text-3xl font-bold text-slate-800 flex items-center gap-3">
        <svg class="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        Approve & Forward
      </h1>
    </div>

    <!-- Warning Banner -->
    <div *ngIf="shareType === 'external'&& !signatureData"
      class="bg-gradient-to-r from-amber-100 to-orange-100 border-l-4 border-amber-500 p-4 rounded-r-lg my-3">
      <div class="flex items-center gap-3">
        <svg class="w-6 h-6 text-amber-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77-1.333.192 3 1.732 3z">
          </path>
        </svg>
        <p class="text-sm font-medium text-amber-800">External Routing: Digital signature required</p>
      </div>
    </div>
    <div class="mb-8">
      <label class="block text-sm font-semibold text-slate-700 mb-3">Share With:</label>
      <div class="inline-flex rounded-lg border border-slate-300 overflow-hidden shadow-sm">
        <button type="button" (click)="shareType = 'internal'" [class.bg-slate-800]="shareType === 'internal'"
          [class.text-white]="shareType === 'internal'" [class.bg-white]="shareType !== 'internal'"
          [class.text-slate-700]="shareType !== 'internal'"
          class="px-6 py-2.5 font-medium text-sm transition-all duration-200 flex items-center gap-2">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
          </svg>
          Internal
        </button>
        <button type="button"  (click)="shareType = 'external'" [class.bg-slate-800]="shareType === 'external'"
          [class.text-white]="shareType === 'external'" [class.bg-white]="shareType !== 'external'"
          [class.text-slate-700]="shareType !== 'external'"
          class="px-6 py-2.5 font-medium text-sm transition-all duration-200 flex items-center gap-2 border-l border-slate-300">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9">
            </path>
          </svg>
          External
        </button>
      </div>
    </div>


    <!-- External Section -->
    <div *ngIf="shareType === 'external'" class="space-y-6 mb-8">
      <div class="mb-6">
        <label class="block text-sm font-semibold text-slate-700 mb-3">Permission Type:</label>
        <div class="flex flex-wrap gap-3">
          <label class="flex items-center cursor-pointer">
            <input type="radio" [(ngModel)]="permissionType" [value]="'edit'" name="internal-permission"
              class="w-4 h-4 text-blue-600 border-slate-300 focus:ring-2 focus:ring-blue-500" />
            <span class="ml-2 text-sm font-medium text-slate-700">Edit/Approve/Recommend</span>
          </label>
          
        </div>
      </div>



      <div>
        <label class="block text-sm font-semibold text-slate-700 mb-2">Select Command</label>
        <div class="w-full">
          <p-dropdown [(ngModel)]="selectedCommand" [options]="commandList" optionLabel="name" optionValue="id"
            [placeholder]="'Choose a command'" name="command" styleClass="w-full rounded" appendTo="body">
          </p-dropdown>
        </div>
      </div>
      <div>
        <label class="block text-sm font-semibold text-slate-700 mb-2">Select Unit</label>
        <p-dropdown [(ngModel)]="selectedUnit" [options]="unitList"
          optionLabel="name" filter="true" filterBy="name" [placeholder]="'Choose a unit'" name="unit"
          styleClass="w-full rounded" appendTo="body">
        </p-dropdown>
        <!-- <p-multiSelect *ngIf="permissionType !== 'edit'" [(ngModel)]="selectedUnits" [options]="unitList"
          optionLabel="name" filter="true" filterBy="name" [placeholder]="'Choose a unit'" name="unit"
          styleClass="w-full rounded" appendTo="body">
        </p-multiSelect> -->
      </div>
    </div>

    <!-- Internal Section -->
    <div *ngIf="shareType === 'internal'" class="mb-8">
      <!-- Permission Type -->
      <div class="mb-6">
        <label class="block text-sm font-semibold text-slate-700 mb-3">Permission Type:</label>
        <div class="flex flex-wrap gap-3">
          <label class="flex items-center cursor-pointer">
            <input type="radio" [(ngModel)]="permissionType" [value]="'edit'" name="internal-permission"
              class="w-4 h-4 text-blue-600 border-slate-300 focus:ring-2 focus:ring-blue-500" />
            <span class="ml-2 text-sm font-medium text-slate-700">Edit/Approve/Recommend</span>
          </label>
          
        </div>
      </div>
      
      <!-- User Selection -->
      <div>
        <label class="block text-sm font-semibold text-slate-700 mb-2">
          {{ permissionType === 'edit' ? 'Select User' : 'Select Users' }}
        </label>
        <p-dropdown id="userSelect" [options]="userList" optionLabel="first_name" filter="true"
          filterBy="first_name,last_name,hrcdf_designation,loginname,unit.name" [(ngModel)]="selectedUser"
          placeholder="Choose a user" appendTo="body" styleClass="w-full rounded">

          <ng-template pTemplate="selectedItem" let-user>
            <div *ngIf="user">
              <small>
                #<strong>{{ user.loginname }}</strong> |
                <strong>{{ user.first_name }} {{ user.last_name }}</strong>
              </small>
            </div>
            <div *ngIf="!user" class="dropdown-placeholder">
              Choose a user
            </div>
          </ng-template>
          <!-- Dropdown list items -->
          <ng-template pTemplate="item" let-user>
            <div class="list-group-item list-group-item-action">
              <small>
                #<strong>{{ user.loginname }}</strong> |
                <strong>{{ user.first_name }} {{ user.last_name }}</strong> | <strong>{{ user.hrcdf_designation
                  }}</strong>
              </small>
            </div>
          </ng-template>
        </p-dropdown>

        <!-- Multi selection for View/Comment permissions -->
        <!-- <p-multiSelect *ngIf="permissionType !== 'edit'" [options]="userList" optionLabel="first_name"
          filterBy="first_name,last_name,hrcdf_designation,loginname,unit.name" [(ngModel)]="selectedUsers"
          placeholder="Choose users" appendTo="body" styleClass="w-full rounded">

          <ng-template pTemplate="item" let-user>
            <div class="list-group-item list-group-item-action">
              <small>
                #<strong>{{ user.loginname }}</strong> |
                <strong>{{ user.first_name }} {{ user.last_name }}</strong> | <strong>{{ user.hrcdf_designation
                  }}</strong>
              </small>
            </div>
          </ng-template>
        </p-multiSelect> -->

      </div>
    </div>

    <!-- Comments -->
    <div class="mb-8">
      <label class="block text-sm font-semibold text-slate-700 mb-2">Comment </label>
      <textarea [(ngModel)]="internalComment" rows="4" placeholder="Add your comments here..."
        class="w-full px-4 py-3 border-2 biredr-gray-500 bg-slate-50 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-slate-700 resize-none"
        name="internalComment"></textarea>
      <div *ngIf="signatureData" class="flex flex-end mt-3">
        <div
          class="flex flex-wrap items-center justify-between bg-blue-50 p-2 border-2 border-blue-500 rounded-lg w-[350px]">
          <div class="flex items-center">
            <div class="mr-4 w-[70px]">
              <img *ngIf="signatureData" [src]="signatureData.qr_code" alt="QR Code"
                class="max-w-full h-auto rounded" />
            </div>
            <div>
              <div class="text-xs text-gray-500 mb-1">
                <span class="font-semibold">Electronically Signed by:</span><br>
                {{ signatureData?.rankName || 'N/A' }}
                {{ signatureData?.first_name }} {{ signatureData?.last_name }}
              </div>
              <div class="text-xs mb-0">
                <span class="text-gray-700 font-semibold">Designation:</span>
                {{ signatureData?.hrcdf_designation || 'N/A' }}
              </div>
              <div class="text-xs">
                <span class="text-gray-700 font-semibold">Directorate:</span>
                {{ signatureData?.unit?.name || 'N/A' }}
              </div>
            </div>
          </div>

        </div>
      </div>
      <button *ngIf="!signatureData" type="button" (click)="addSignature()"
        class="px-2 py-1 text-xs bg-blue-100 text-blue-700 rounded hover:bg-blue-200 transition-all float-right mb-4">
        Add Signature
      </button>
    </div>



    <!-- Action Buttons -->
    <div class="flex flex-wrap gap-3 justify-end">
      <button type="button" (click)="closeDialog.emit()"
        class="px-4 py-1 bg-white border-2 border-slate-300 text-slate-700 rounded font-medium hover:bg-slate-50 transition-all duration-200 shadow-sm">
        Cancel
      </button>
      <button (click)="submitShare()" [disabled]="isLoading || (shareType === 'external'&& !signatureData)"
        [class.opacity-50]="isLoading" [class.cursor-not-allowed]="isLoading"
        class="px-4 py-1 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded font-medium hover:from-blue-700 hover:to-blue-800 transition-all duration-200 shadow-lg hover:shadow-xl flex items-center gap-2 disabled:from-slate-400 disabled:to-slate-500">
        <svg *ngIf="!isLoading" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
        </svg>
        <svg *ngIf="isLoading" class="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
          </path>
        </svg>
        {{ isLoading ? 'Submitting...' : 'Submit' }}
      </button>
    </div>
    <!-- </form> -->
  </div>
</div>
</div>